import { KoopkrachtpremieComponent } from './modules/koopkrachtpremie/koopkrachtpremie.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AanwerfsimulatorComponent } from './modules/aanwerfsimulator/aanwerfsimulator.component';
import { AdminComponent } from './admin/admin.component';
import { PrivateAdminComponent } from './admin/private-admin/private-admin.component';
import { Cash4BikeComponent } from './modules/cash4-bike/cash4-bike.component';
import { AuthGuard } from './guard/auth.guard';
import { ManualNavigationGuard } from './guard/manual-navigation.guard';
import { PrivateAdminGuardGuard } from './guard/private-admin-guard.guard';
import { SecureInnerPagesGuard } from './guard/secure-inner-pages.guard';
import { HolidayValueComponent } from './modules/holiday-value/holiday-value.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SstoolsComponent } from './sstools/sstools.component';
import { VaaComponent } from './modules/vaa-module/vaa.component';
import { UnderConstructionComponent } from './shared/under-construction/under-construction.component';
import { OpzegtermijnComponent } from './modules/opzegtermijn/opzegtermijn.component';

// Routing of the application
const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [SecureInnerPagesGuard],
    data: {
      noHeader: true,
    },
  },

  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      noHeader: true,
    },
    // canActivate:[ManualNavigationGuard]
  },
  {
    path: 'wachtwoord-reset',
    component: ResetPasswordComponent,
    // canActivate: [ManualNavigationGuard],
    data: {
      noHeader: true,
    },
  },
  {
    path: 'privateAdmin',
    component: PrivateAdminComponent,
    canActivate: [PrivateAdminGuardGuard]
  },
  {
    path: 'pagina-niet-gevonden',
    component: NotFoundComponent,
    data: {
      noHeader: true,
    },
  },
  {
    path: 'under-construction',
    component: UnderConstructionComponent,
    data: {
      noHeader: true,
    },
  },
  {
  path:  ':ondernemingNaam',
  component: SstoolsComponent,
  children: [
    {
      path: 'tools',
      component: LandingPageComponent
    },
    {
      path: 'vaa',
      component: VaaComponent,
      canActivate: [SecureInnerPagesGuard]
    },
    {
      path: 'cash4Bike',
      component: Cash4BikeComponent,
      canActivate: [SecureInnerPagesGuard]
    },
    {
      path: 'koopkrachtpremie',
      component: KoopkrachtpremieComponent,
      canActivate: [SecureInnerPagesGuard]
    },
    {
      path: 'holidayValue',
      component: HolidayValueComponent,
      canActivate: [SecureInnerPagesGuard]
    },
    {
      path: 'opzegtermijn',
      component: OpzegtermijnComponent,
      canActivate: [SecureInnerPagesGuard]
    },
    {
      path: 'aanwerfsimulator',
      component: AanwerfsimulatorComponent,
      canActivate: [SecureInnerPagesGuard]
    },
    {
      path: 'admin',
      component: AdminComponent,
      canActivate: [AuthGuard]
    },
  ],

  },
  {
    path: ':ondernemingNaam/:ondernemingId/tools', redirectTo: ':ondernemingNaam/tools'
  },
  {
    path: ':ondernemingNaam/:ondernemingId/vaa', redirectTo: ':ondernemingNaam/vaa'
  },
  {
    path: ':ondernemingNaam/:ondernemingId/cash4Bike', redirectTo: ':ondernemingNaam/cash4Bike'
  },
  {
    path: ':ondernemingNaam/:ondernemingId/holidayValue', redirectTo: ':ondernemingNaam/holidayValue'
  },
  {
    path: ':ondernemingNaam/:ondernemingId/aanwerfsimulator', redirectTo: ':ondernemingNaam/aanwerfsimulator'
  },
  {
    path: ':ondernemingNaam/:ondernemingId/admin', redirectTo: ':ondernemingNaam/admin'
  },
  {
    path: ':ondernemingNaam/:ondernemingId/opzegtermijn', redirectTo: ':ondernemingNaam/opzegtermijn'
  },
 
  { path: '**', redirectTo: 'pagina-niet-gevonden'},
  ];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
